import { template as template_0ed35e8f74d24d9ba45be39fa1c54f5f } from "@ember/template-compiler";
import BsForm from 'eflex/components/bs-form';
export default template_0ed35e8f74d24d9ba45be39fa1c54f5f(`
<BsForm @model={{this}} @readonly={{true}} as |form|>
  <form.element
    class="jem-model-display mb-0"
    @controlType="text"
    @size="lg"
    @value={{if @productionScheduleEnabled @productionScheduleModelCode @buildStatusModelCode}}
  as |el|>
    <el.control
      class="fw-semibold"
      title={{el.value}}
    />
  </form.element>
</BsForm>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
